import { render, staticRenderFns } from "./docket.vue?vue&type=template&id=f1c86a0c&scoped=true"
import script from "./docket.vue?vue&type=script&lang=js"
export * from "./docket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c86a0c",
  null
  
)

export default component.exports